import { Component, OnInit, Input } from '@angular/core';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-other-ref',
  templateUrl: './other-ref.component.html',
  styleUrls: ['./other-ref.component.scss']
})
export class OtherRefComponent implements OnInit {

  @Input() list: [];
  @Input() titleBloc: string;
  @Input() imgPath: string;
  @Input() color: string;
  @Input() isAlert: boolean;
  @Input() tag;
  panelOpenState = false;

  constructor(private atInternetService : AtInternetService) { }

  ngOnInit(): void {
  }

  isPanelOpen() {    
    var width = window.outerWidth;
  
    if(this.isAlert && this.list.length > 1){  
        return false;     
    } 
    if(!this.isAlert && width < 600 ) {
      return false
    }        
    return true;
  }
  generateTagIfOpen(){
    if(this.panelOpenState){  
      this.atInternetService.generateClickAction(
        this.tag, 
        'chevrons_autres_references', 
        'chevron_ouvert'
      );
    }    
  }
}